export default __webpack_public_path__ + "assets/a7.9db1a76a.jpg";